export enum Segment {
    QSR = 'qsr',
    FastCasual = 'fast casual',
    Midscale = 'midscale',
    CasualDining = 'casual dining',
    FineDining = 'fine dining'
}

export const segmentList = [Segment.QSR, Segment.FastCasual, Segment.Midscale, Segment.CasualDining, Segment.FineDining];